import { SignOutButton, useUser } from "@clerk/clerk-react";
import { Menu } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/herba-logo.svg";
import { NAV_ITEMS, PAGES } from "../../constants/pages";
import NameCircle from "../nameCircle/NameCircle";

const MobileNav = () => {
  const { user } = useUser();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <div className="block md:hidden bg-blue-50 shadow-md w-full p-4">
        <div className="flex justify-between items-center">
          <Link to="/">
            <img src={logo} alt="Herba Logo" className="h-8 w-auto" />
          </Link>
          <div
            className="cursor-pointer"
            onClick={() => setIsMenuOpen((prevState) => !prevState)}
          >
            <Menu />
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="block md:hidden absolute w-full bg-white z-50 shadow-md">
          {NAV_ITEMS.filter((navItem) => navItem.accessible(user)).map(
            (navItem, idx) => (
              <a
                key={idx}
                href={navItem.href}
                className={`
                                flex items-center px-5 py-6 text-sm font-bold
                                ${
                                  window.location.pathname === navItem.href ||
                                  (window.location.pathname === "/" &&
                                    navItem.href === PAGES.DASHBOARD)
                                    ? "bg-blue-200 text-blue-600"
                                    : "text-blue-600 hover:bg-blue-200"
                                }
                            `}
              >
                {navItem.image} {navItem.link}
              </a>
            )
          )}
          <div className="flex items-center px-5 py-6">
            {user?.imageUrl && (
              <img
                src={user.imageUrl}
                alt="User Avatar"
                className="h-7 w-7 rounded-full mr-3"
              />
            )}
            {!user?.imageUrl && (
              <NameCircle
                name={user?.fullName || ""}
                index={0}
                greyScale={true}
              />
            )}
            <div>
              <p className="text-sm font-semibold text-grey-900 ">
                {user?.fullName || ""}
              </p>
              <SignOutButton>
                <span className="text-sm font-semibold text-blue-600 hover:underline cursor-pointer">
                  Logout
                </span>
              </SignOutButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav;
